@if (inputService.show) {
  <ng-container [formGroup]="customFormGroup">
    <div class="compare-input fx-row fx-justify-start fx-items-center" style="gap: 50px">
      <mat-form-field>
        @if (inputService.inputConfig.readOnly) {
          <input matInput readonly type='text' formControlName='compare' />
        }
        @if (!inputService.inputConfig.readOnly) {
          <mat-select [placeholder]="inputService.inputConfig.placeholder | translate" formControlName='compare'>
            <mat-option value='>'>
              <span>></span>
            </mat-option>
				<mat-option value='>='>
					<span>>=</span>
				</mat-option>
				<mat-option value='='>
					<span>=</span>
				</mat-option>
				<mat-option value='<'>
					<span><</span>
				</mat-option>
				<mat-option value='<='>
					<span><=</span>
				</mat-option>
			</mat-select>
}
		</mat-form-field>
		<mat-form-field class="fx-flex-1-1-0">
			<mat-label>{{inputService.computedTitle | translate}}</mat-label>
			<input [required]='inputService.inputConfig.required' [readonly]='inputService.inputConfig.readOnly' matInput [matDatepickerFilter]="dateFilterBinded" [matDatepicker]="dp3" [placeholder]="inputService.inputConfig.placeholder | translate" formControlName='date' (click)='dp3.open()' readonly>
			<mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
			<mat-datepicker  #dp3></mat-datepicker>
			@if (!inputService.control.valid) {
<mat-error>{{inputService.errorMessage | translate}}</mat-error>
}
		</mat-form-field>
	</div>
</ng-container>
}